<template>
  <div class="modal-custom-k">
    <div class="modal-content-custom">
      <div class="modal-box-custom" :style="styles">
        <div class="modal-header-custom">
          <h1 class="modal-header-text">
            {{ title }}
          </h1>

          <feather type="x" size="20px" class="modal-icon-custom" @click="$emit('closemodal')" />
        </div>

        <div class="modal-container-custom">
          <slot name="modalcontent" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
	props: {
		title: {
			type: String,
			default: 'Modal',
		},
		width: {
			type: String,
			default: '30%',
		},
		maxWidth: {
			type: String,
			default: 'unset',
		},
	},
	data() {
		return {};
	},
	computed: {
		styles() {
			return {
				width: this.width,
				maxWidth: this.maxWidth,
			};
		},
	},
	created() {
		this.$emit('created');
	},

	methods: {
		uniqueCheck(e) {
			this.additional_grouped = [];

			if (e.target.checked) {
				this.additional_grouped.push(e.target.value);
			}
		},
	},
};
</script>

<style scoped>
@import '~@/style/Global.css';
.modal-container-custom {
	padding: 20px;
}

.modal-icon-custom {
	cursor: pointer;
}
.modal-custom-k {
	position: fixed;
	z-index: 9999;
	top: 0;
	left: 0;
	width: 100%;
	height: 100vh;
	background-color: rgba(0, 0, 0, 0.137);
	display: table;
	transition: all 0.5s ease;
	overflow-y: scroll;
	align-items: flex-end;
}

.button-container {
	display: flex;
	width: 100%;
}

.modal-content-custom {
	display: flex;
	z-index: 99;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
	transition: all 0.5s ease;
}

.modal-box-custom {
	transition: all 0.5s ease;
	z-index: 99;
	border-radius: 5px;
	background-color: #fff;
	box-shadow: var(--default-box-shadow);
}

.modal-header-custom {
	padding: 15px 20px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	border-bottom: 1px solid rgba(223, 223, 223, 0.342);
}

.modal-header-text {
	font-size: 14px;
	font-weight: 500;
}
</style>
